import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { errorMiddleware } from "./middleware/errorMiddleware";
import { loaderMiddleware } from "./middleware/loaderMiddleware";
import { rootReducer } from "./reducers";
import { rootSaga } from "./sagas";

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      sagaMiddleware,
      loaderMiddleware,
      errorMiddleware
    ),
});

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
